<template>
        <v-flex>
            <v-layout row class="content-header">
                <v-flex md12 class="content-title">
                    <h2>Formulários</h2>
                    <h4>Faça download dos arquivos que constam as informações necessárias para abertura de sinistros.</h4>
                </v-flex>
            </v-layout>

            <v-layout row class="content-body overflow-y-auto">
                <v-flex md12>
                    <v-data-table
                        :headers="headers"
                        :items="formularios"
                        :sort-by="['atualizadoEm', 'documento']"
                        :sort-desc="[true]"                         
                        class="">
                        <template v-slot:item.documento="{ item }">
                            {{ item.documento }} 
                            <v-tooltip top v-if="item.info != ''">
                                <template v-slot:activator="{ on }">
                                    <i class="mdi mdi-help-circle hover" v-on="on"></i>
                                </template>
                                <span>{{ item.info }}</span>
                            </v-tooltip>                            
                        </template>
                        <template v-slot:item.arquivo="{ item }">
                            <img class="hover" src="/img/icon-pdf.png" @click="gerarArquivo(item.arquivo, item.arquivoNome)" />
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>

        </v-flex>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex';
import Helpers from "@/utilities/Helpers";

export default {
    mixins: [Helpers],
    data() {
        return {
            headers: [
                {text: "Documento", value: "documento", sortable: true},
                {text: "Download", value: "arquivo", sortable: false},
                {text: "Atualizado Em", value: "atualizadoEm", sortable: true}
            ],
            formularios: []
        }
    },        
    methods: {
        requestFormularios(){
            this.formularios = [
                {
                    documento: "MODELO - AUTORIZAÇÃO DE PAGAMENTO",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/autorizacao_de_pagamento.pdf",
                    arquivoNome: "autorizacao_de_pagamento.pdf",
                    info: ""
                },
                {
                    documento: "MODELO - AUTORIZAÇÃO DE PAGAMENTO - PESSOA JURÍDICA",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/autorizacao_de_pagamento_pessoa_juridica.pdf",
                    arquivoNome: "autorizacao_de_pagamento_pessoa_juridica.pdf",
                    info: ""
                },
                {
                    documento: "MODELO - DECLARAÇÃO DE RESIDÊNCIA",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/declaracao_de_residencia.pdf",
                    arquivoNome: "declaracao_de_residencia.pdf",
                    info: ""
                },
                {
                    documento: "MODELO - DECLARAÇÃO DE HERDEIROS E DE VIDA MARITAL",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/nova_declaracao_de_herdeiros_previsul.pdf",
                    arquivoNome: "nova_declaracao_de_herdeiros_previsul.pdf",
                    info: ""
                }, 
                {
                    documento: "AVISO DE SINISTRO - DOENÇAS GRAVES",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_dg.pdf",
                    arquivoNome: "novo_formulario_de_dg.pdf",
                    info: ""
                }, 
                
                {
                    documento: "AVISO DE SINISTRO - DIÁRIA DE INCAPACIDADE TEMPORÁRIA",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_dit.pdf",
                    arquivoNome: "novo_formulario_de_dit.pdf",
                    info: ""
                }, 
                
                {
                    documento: "AVISO DE SINISTRO - DESPESA MÉDICA, HOSPITALAR E ODONTOLÓGICA",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_dmho.pdf",
                    arquivoNome: "novo_formulario_de_dmho.pdf",
                    info: ""
                }, 
                
                {
                    documento: "AVISO DE SINISTRO - INVALIDEZ FUNCIONAL PERMANENTE E TOTAL POR DOENÇA",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_ifpd.pdf",
                    arquivoNome: "novo_formulario_de_ifpd.pdf",
                    info: ""
                }, 
                
                {
                    documento: "AVISO DE SINISTRO - INVALIDEZ PERMANENTE POR ACIDENTE",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_ipa.pdf",
                    arquivoNome: "novo_formulario_de_ipa.pdf",
                    info: ""
                }, 
                
                {
                    documento: "AVISO DE SINISTRO - MORTE PRESTAMISTA (quando solicitado)",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_morte_prestamista.pdf",
                    arquivoNome: "novo_formulario_de_morte_prestamista.pdf",
                    info: ""
                }, 
                
                {
                    documento: "AVISO DE SINISTRO - MORTE COMPLETO",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_morte.pdf",
                    arquivoNome: "novo_formulario_de_morte.pdf",
                    info: ""
                },  
                
                {
                    documento: "AVISO DE SINISTRO - RENDA DIÁRIA DE INTERNAÇÃO HOSPITALAR",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_rdih.pdf",
                    arquivoNome: "novo_formulario_de_rdih.pdf",
                    info: ""
                },  
                
                {
                    documento: "AVISO DE SINISTRO - RENDA TEMPORÁRIA (MENSAL) POR INCAPACIDADE",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/novo_formulario_de_rmti_rti.pdf",
                    arquivoNome: "novo_formulario_de_rmti_rti.pdf",
                    info: ""
                },  
                
                {
                    documento: "MODELO - TERMO DE CESSÃO DE DIREITOS",
                    atualizadoEm: "23/09/2022",
                    arquivo: "/upload/sinistro/termo_cessao_direitos.pdf",
                    arquivoNome: "termo_cessao_direitos.pdf",
                    info: ""
                },                              
            ];
        },
        gerarArquivo(value, downloadName){
            let _link = document.createElement('a');
            _link.href = value;
            _link.download = downloadName;
            _link.click();
            URL.revokeObjectURL(_link.href);
        }
    },
    computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
    },
    mounted(){
        this.requestFormularios()
    }        
}
</script>
